import {
  Badge,
  Card,
  Col,
  DatePicker,
  Progress,
  Row,
  Segmented,
  Select,
  Skeleton,
  Space,
  Spin,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import { ScaleLinear } from "d3-scale";
import { Line } from "@ant-design/charts";

import Meta from "antd/es/card/Meta";
import { IncomeExpensesGraphs, SalesBarChart } from "./DashboardGraphs";
import { AiFillBank } from "react-icons/ai";
import "../../Common/Dashboardlayout.css";
import { BsCurrencyRupee } from "react-icons/bs";
import { useContext, useEffect, useState } from "react";
import DashboardService from "../../Services/DashboardService";
import { useClient } from "../../Context/ClientContext";
import { Utils } from "../../../Utilities/Utils";
import { percentToRs } from "../../Common/CAPComponents";
import { notificationContext } from "../../Common/PageRoute";
import { dayjs } from "../../../Utilities/dayjs";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useTheme } from "../../Context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { SalesBarCharts } from "./NewDashBoardGraphs";
import {
  areaElementClasses,
  LineChart,
  PieChart,
  SparkLineChart,
  useDrawingArea,
  useYScale,
} from "@mui/x-charts";
import ReactECharts from "echarts-for-react";
import TopSegment from "./TopSegment";
import { useRole } from "../../../Context/RoleContext";

const NewDashboard: React.FC = () => {
  const { RangePicker } = DatePicker;
  const themeData: any = useTheme();
  const navigate = useNavigate();
  const { currentClient, companySettings } = useClient();
  const [data, setData] = useState<any>({});
  const [cashOrAccrual, setCashOrAccrual] = useState<any>("Accrual");
  const { openNotification } = useContext(notificationContext);
  const [hideDasBackground, sethideDasBackground] = React.useState(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [filterDate, setFilterDate] = React.useState<any>(
    JSON.parse(localStorage.getItem("LockPeriod")!)
      ? {
          from: JSON.parse(localStorage.getItem("LockPeriod")!).from,
          to: JSON.parse(localStorage.getItem("LockPeriod")!).to,
        }
      : {
          from: dayjs(companySettings?.period?.from).format("DD/MM/YYYY"),
          to: dayjs(companySettings?.period?.to).format("DD/MM/YYYY"),
        }
  );

  const [width, setWidth] = React.useState<any>(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  console.log(width, "this is sjfjasdkfjaskdjfwitdh");
  useEffect(() => {
    // DashboardService.getDashboardData(
    //   currentClient?.id!,
    //   filterDate.fromDate,
    //   filterDate.toDate
    // ).then((res) => {
    //   setData(res?.result);
    // });
  }, [currentClient?.id, filterDate]);
  console.log("dataaaaaaa", data);
  // console.log("title", data?.bankSummary?.title);
  const RoundPercent = (due: any, total: any) => {
    const per = percentToRs(due, total);
    const math = Math.round(per * 100) / 100;
    return math;
  };

  const handleChange = (checked: boolean) => {
    sethideDasBackground(checked);
  };

  const { getRole } = useRole();

  // console.log("getRole", getRole());

  // console.log("check", hideDasBackground);

  React?.useEffect(() => {
    if (currentClient?.id) {
      getList(
        currentClient.id,
        dayjs(filterDate.from, "DD/MM/YYYY").toISOString(),
        dayjs(filterDate.to, "DD/MM/YYYY").endOf("day").toISOString()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, filterDate.from, filterDate.to]);

  const getList = async (
    clientId: string,
    fromDate: string = "",
    toDate: string = ""
  ) => {
    setLoading(true);
    await DashboardService?.getDashboardData(clientId, fromDate, toDate).then(
      (res: any) => {
        if (res) {
          setData(res?.result);
          setLoading(false);
        }
      }
    );
  };
  const style = {
    perodic: {
      background: "rgba(221, 220, 220, 0.25)",
      marginLeft: "5px",
    },
  };
  // ---------This functions for range Picker handling-------------
  const getQuarterPreset: any = (startMonth: number) => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() + startMonth).startOf("month"),
      fromDate.month(fromDate.month() + startMonth + 2).endOf("month"),
    ];
  };
  const thisYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month()).startOf("month"),
      fromDate.month(fromDate.month() + 11).endOf("month"),
    ];
  };
  const lastYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() - 12).startOf("month"),
      fromDate.month(fromDate.month() - 1).endOf("month"),
    ];
  };

  const getLast15Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(15, "day").startOf("day"); // Start 15 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };
  const getLast7Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(7, "day").startOf("day"); // Start 7 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };

  const getThisMonth = () => {
    const now = dayjs();
    return [now.startOf("month"), now.endOf("month")];
  };
  const getLastMonth = () => {
    const now = dayjs();
    const lastMonth = now.subtract(1, "month");
    return [lastMonth.startOf("month"), lastMonth.endOf("month")];
  };

  return (
    <div
      style={{
        height: `calc(100vh - 150px)`,
        padding: "0px",
        // overflowY: "auto",
      }}
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined />}
        style={{
          justifyContent: "center",
          marginTop: "180px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: "5px",
            // backgroundColor: "rgb(247, 248, 250)",
            borderRadius: "15px",
            marginTop: "5px",
          }}
        >
          <Row
            justify={"space-between"}
            // style={{ background: "skyblue" }}
          >
            <Col>
              <Typography.Title
                // className="customtext"
                level={3}
                style={{
                  color: themeData?.themeData?.themeColor,
                  // fontFamily: "REM,sans-serif",
                  fontWeight: 400,
                  padding: "0px 0px 0px 5px",
                }}
              >
                Dashboard
              </Typography.Title>
            </Col>

            <Col>
              <span>Privacy</span>
              <Switch
                style={{ margin: "5px 20px 5px 5px" }}
                checked={hideDasBackground}
                onChange={handleChange}
              />
              <RangePicker
                allowClear={false}
                defaultValue={[
                  dayjs(
                    dayjs(companySettings?.period?.from, {
                      format: "YYYY-MM-DDTHH:mm:ssZ",
                    }).format("DD/MM/YYYY"),
                    "DD/MM/YYYY"
                  ),
                  dayjs(
                    dayjs(companySettings?.period?.to, {
                      format: "YYYY-MM-DDTHH:mm:ssZ",
                    }).format("DD/MM/YYYY"),
                    "DD/MM/YYYY"
                  ),
                ]}
                format="DD/MM/YYYY"
                style={{
                  width:
                    // width <= 464 ? "210px" :
                    width == 375 ? "200px" : "250px",
                  border: "1px solid #f1f3ff",
                }}
                onChange={(e: any) => {
                  if (e === null) {
                    setFilterDate({});
                  } else {
                    setFilterDate({
                      ...filterDate,
                      from: dayjs(e[0]).format("DD/MM/YYYY"),
                      to: dayjs(e[1]).format("DD/MM/YYYY"),
                    });
                    localStorage.setItem(
                      "LockPeriod",
                      JSON.stringify({
                        ...filterDate,
                        from: dayjs(e[0]).format("DD/MM/YYYY"),
                        to: dayjs(e[1]).format("DD/MM/YYYY"),
                      })
                    );
                    openNotification("success", `Period locked.`);
                  }
                }}
                presets={[
                  {
                    label: "Today",
                    value: [dayjs().add(0, "d"), dayjs()],
                  },
                  {
                    label: "Last 7 Days",
                    value: getLast7Days(),
                  },
                  {
                    label: "Last 15 Days",
                    value: getLast15Days(),
                  },
                  {
                    label: "This Month",
                    value: getThisMonth(),
                  },
                  {
                    label: "Last Month",
                    value: getLastMonth(),
                  },
                  {
                    label: "Quarter 1",
                    value: getQuarterPreset(0),
                  },
                  {
                    label: "Quarter 2",
                    value: getQuarterPreset(3),
                  },
                  {
                    label: "Quarter 3",
                    value: getQuarterPreset(6),
                  },
                  {
                    label: "Quarter 4",
                    value: getQuarterPreset(9),
                  },
                  {
                    label: "This Year",
                    value: thisYear(),
                  },
                  {
                    label: "Last Year",
                    value: lastYear(),
                  },
                ]}
              />
              <Segmented<string>
                options={[
                  "Today",
                  "This week",
                  "Last week",
                  "This month",
                  "Last month",
                  "This year",
                  "Last year",
                ]}
                onChange={(value) => {
                  console.log(value);
                }}
                style={style.perodic}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <TopSegment />
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              gap: "10px",

              // marginTop: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <Col lg={15} xs={12} md={12} xl={24}>
                <Card
                  className="dasGraph"
                  style={{ marginTop: "10px", backgroundColor: "transparent" }}
                >
                  <Row
                  // style={{
                  //   paddingTop: "5px",
                  // }}
                  >
                    <Col xs={24} lg={24} md={24}>
                      {window.innerWidth <= 300 ? (
                        <>
                          <h1>Total Sales</h1>
                          <Tooltip>
                            <Progress
                              size={100}
                              strokeWidth={10}
                              percent={30}
                              strokeColor={themeData?.themeData?.themeColor}
                              success={{ percent: 15 }}
                              type="circle"
                            />
                          </Tooltip>
                        </>
                      ) : (
                        <SalesBarCharts
                          data={data}
                          hideDasBackground={hideDasBackground}
                        />
                      )}
                    </Col>
                  </Row>
                </Card>
              </Col>
            </div>
            <div style={{ marginTop: "10px", width: "50%" }}>
              <Row style={{ width: "100%" }}>
                <Col lg={12} xs={24} md={12} xl={12}>
                  <Skeleton loading={loading}>
                    <Card
                      className="set-pt"
                      actions={[
                        <>
                          <p
                            style={{
                              color: "#52c41a",
                            }}
                          >
                            Due
                          </p>
                          {hideDasBackground ? (
                            <>****</>
                          ) : (
                            <>
                              <p>
                                {Utils.getFormattedNumber(
                                  data?.receivables?.due
                                )}
                              </p>
                            </>
                          )}
                        </>,
                        <>
                          <p
                            style={{
                              color: "#1677ff",
                            }}
                          >
                            Overdue{" "}
                          </p>
                          {hideDasBackground ? (
                            <>****</>
                          ) : (
                            <>
                              <p>
                                {Utils.getFormattedNumber(
                                  data?.receivables?.overdue
                                )}
                              </p>
                            </>
                          )}
                        </>,
                      ]}
                    >
                      <Meta
                        title={
                          <Typography.Title
                            level={5}
                            style={{ fontWeight: 500, marginBottom: "0px" }}
                          >
                            <p
                              style={{
                                color: themeData?.themeData?.themeColor,
                                cursor: "pointer",
                                marginBottom: "0px",
                              }}
                              onClick={() =>
                                navigate(
                                  `/billing/clients/${currentClient?.id}/sales/invoices`
                                )
                              }
                            >
                              {" "}
                              Total Receivables
                            </p>
                          </Typography.Title>
                        }
                        description={
                          hideDasBackground ? (
                            <>Total Unpaid Invoices ****</>
                          ) : (
                            <>
                              {`Total Unpaid Invoices 
                        ${Utils.getFormattedNumber(
                          data?.receivables?.totalDue
                        )}`}
                            </>
                          )
                        }
                      />

                      <Tooltip
                        title={`${
                          isNaN(
                            (data?.receivables?.due * 100) /
                              data?.receivables?.totalDue
                          )
                            ? 0
                            : RoundPercent(
                                data?.receivables?.due,
                                data?.receivables?.totalDue
                              )
                        } % due  /  ${
                          isNaN(
                            (data?.receivables?.overdue * 100) /
                              data?.receivables?.totalDue
                          )
                            ? 0
                            : RoundPercent(
                                data?.receivables?.overdue,
                                data?.receivables?.totalDue
                              )
                        } % Overdue`}
                      >
                        {/* <Progress
                          showInfo={false}
                          percent={100}
                          strokeColor={themeData?.themeData?.themeColor}
                          success={{
                            percent: RoundPercent(
                              data?.receivables?.due,
                              data?.receivables?.totalDue
                            ),
                            // strokeColor: themeData?.themeData?.themeColor
                          }}
                        /> */}
                        <span>
                          <PieChart
                            series={[
                              {
                                data: [
                                  { id: 0, value: 10, color: "#C7253E" },
                                  { id: 1, value: 15, color: "#72BF78" },
                                ],
                                innerRadius: 0,
                                outerRadius: 45,
                                // paddingAngle: -115,
                                cornerRadius: 5,
                                // startAngle: -1,
                                // endAngle: 285,
                                cx: 130,
                                cy: 50,
                              },
                            ]}
                            height={105}
                          />
                        </span>
                      </Tooltip>
                    </Card>
                  </Skeleton>
                </Col>
                <Col lg={12} xs={24} md={12} xl={12}>
                  <Skeleton loading={loading}>
                    <Card
                      className="set-pt"
                      style={{ marginLeft: "5px" }}
                      actions={[
                        <>
                          <p style={{ color: "#52c41a" }}>Due</p>
                          {hideDasBackground ? (
                            <>****</>
                          ) : (
                            <>
                              <p>
                                {Utils.getFormattedNumber(data?.payables?.due)}
                              </p>
                            </>
                          )}
                        </>,
                        <>
                          <p style={{ color: "#1677ff" }}>Overdue </p>
                          {hideDasBackground ? (
                            <>****</>
                          ) : (
                            <>
                              <p>
                                {Utils.getFormattedNumber(
                                  data?.payables?.overdue
                                )}
                              </p>
                            </>
                          )}
                        </>,
                      ]}
                    >
                      <Meta
                        title={
                          <Typography.Title
                            level={5}
                            style={{
                              // fontFamily: "REM,sans-serif",
                              fontWeight: 500,
                              marginBottom: "0px",
                              // color: "rgb(68, 84, 111)",
                            }}
                          >
                            <p
                              style={{
                                color: themeData?.themeData?.themeColor,
                                cursor: "pointer",
                                marginBottom: "0px",
                              }}
                              onClick={() =>
                                navigate(
                                  `/billing/clients/${currentClient?.id}/purchase/purchaseBill`
                                )
                              }
                            >
                              Total Payables
                            </p>
                          </Typography.Title>
                        }
                        description={
                          hideDasBackground ? (
                            <p>Total Unpaid Bills ****</p>
                          ) : (
                            <>
                              {`Total Unpaid Bills 
                        ${Utils.getFormattedNumber(data?.payables?.totalDue)}`}
                            </>
                          )
                        }
                      />
                      <Tooltip
                        title={`${
                          isNaN(
                            (data?.payables?.due * 100) /
                              data?.payables?.totalDue
                          )
                            ? 0
                            : RoundPercent(
                                data?.payables?.due,
                                data?.payables?.totalDue
                              )
                        } % due  /  ${
                          isNaN(
                            (data?.payables?.overdue * 100) /
                              data?.payables?.totalDue
                          )
                            ? 0
                            : RoundPercent(
                                data?.payables?.overdue,
                                data?.payables?.totalDue
                              )
                        } % Overdue`}
                      >
                        <PieChart
                          series={[
                            {
                              data: [
                                {
                                  id: 0,
                                  value: 15,
                                  color: "#3674B5",
                                },
                                { id: 1, value: 10, color: "#72BF78" },
                              ],
                              innerRadius: 0,
                              outerRadius: 45,
                              // paddingAngle: -115,
                              cornerRadius: 5,
                              // startAngle: 10,
                              // endAngle: 285,
                              cx: 130,
                              cy: 50,
                            },
                          ]}
                          height={105}
                        />
                      </Tooltip>
                    </Card>
                  </Skeleton>
                </Col>
              </Row>
              <Row style={{ width: "100%", marginTop: "5px" }}>
                <Col lg={12} xs={24} md={12} xl={12}>
                  <Skeleton loading={loading}>
                    <Card className="cashflow set-pt">
                      <Typography.Title
                        level={5}
                        style={{
                          // fontFamily: "REM,sans-serif",
                          fontWeight: 500,

                          // color: "rgb(68, 84, 111)",
                        }}
                      >
                        <BsCurrencyRupee
                          size={20}
                          style={{
                            color: themeData?.themeData?.themeColor,
                            cursor: "pointer",
                          }}
                        />{" "}
                        <span
                          style={{
                            color: themeData?.themeData?.themeColor,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(
                              `/billing/clients/${currentClient?.id}/banking/bankAccounts`
                            )
                          }
                        >
                          {data?.bankSummary?.title}
                        </span>
                      </Typography.Title>
                      <Row
                        gutter={[0, width <= 1440 ? 41 : 41]}
                        style={{ rowGap: "15px" }}
                      >
                        <Col lg={12} xl={14} md={12}>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "lightslategray",
                              fontWeight: 500,
                            }}
                          >
                            Bank (
                            {dayjs(companySettings?.period?.from).format(
                              "DD/MM/YYYY"
                            )}
                            )
                          </p>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "lightslategray",
                              fontWeight: 500,
                            }}
                          >
                            <span>
                              {hideDasBackground ? (
                                <>****</>
                              ) : (
                                <>
                                  {Utils?.getFormattedNumber(
                                    data?.bankSummary?.openingBalance
                                  )}
                                </>
                              )}
                            </span>
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          md={12}
                          xl={8}
                          xs={12}
                          style={{ fontSize: "12px", textAlign: "end" }}
                        >
                          <p
                            style={{
                              color: "green",
                              fontWeight: 500,
                              marginLeft: "-12px",
                            }}
                          >
                            Incoming
                          </p>{" "}
                          <p style={{ fontSize: "12px" }}>
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils?.getFormattedNumber(
                                  data?.bankSummary?.incoming
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          md={12}
                          xl={14}
                          style={{ fontSize: "12px" }}
                        >
                          <p
                            style={{
                              color: "#268ddd",
                              fontWeight: 500,
                            }}
                          >
                            Bank (
                            {dayjs(companySettings?.period?.to).format(
                              "DD/MM/YYYY"
                            )}
                            )
                          </p>

                          <p>
                            {" "}
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils?.getFormattedNumber(
                                  data?.bankSummary?.closingBalance
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          xl={8}
                          md={12}
                          xs={12}
                          style={{ fontSize: "12px", textAlign: "end" }}
                        >
                          <p
                            style={{
                              color: "red",
                              marginLeft: "-12px",
                              fontWeight: 500,
                            }}
                          >
                            Outgoing
                          </p>
                          <p>
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils?.getFormattedNumber(
                                  Math.abs(data?.bankSummary?.outgoing)
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                      </Row>
                    </Card>
                  </Skeleton>
                </Col>
                <Col lg={12} xs={24} md={12} xl={12}>
                  <Skeleton loading={loading}>
                    <Card
                      className="cashflow set-pt"
                      style={{ marginLeft: "5px" }}
                    >
                      <Typography.Title
                        level={5}
                        style={{
                          // fontFamily: "REM,sans-serif",
                          fontWeight: 500,

                          // color: "rgb(68, 84, 111)",
                          color: themeData?.themeData?.themeColor,
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(
                            `/billing/clients/${currentClient?.id}/banking/cashInHand`
                          )
                        }
                      >
                        <BsCurrencyRupee size={20} /> {data?.cashSummary?.title}
                      </Typography.Title>

                      <Row
                        gutter={[0, width <= 1440 ? 41 : 41]}
                        style={{ rowGap: 15 }}
                      >
                        <Col lg={12} xl={14} md={12}>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "lightslategray",
                              fontWeight: 500,
                            }}
                          >
                            Cash (
                            {dayjs(companySettings?.period?.from).format(
                              "DD/MM/YYYY"
                            )}
                            )
                          </p>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "lightslategray",
                              fontWeight: 500,
                            }}
                          >
                            <span>
                              {hideDasBackground ? (
                                <>****</>
                              ) : (
                                <>
                                  {Utils.getFormattedNumber(
                                    data?.cashSummary?.openingBalance
                                  )}
                                </>
                              )}
                            </span>
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          md={12}
                          xl={8}
                          xs={12}
                          style={{ fontSize: "12px", textAlign: "end" }}
                        >
                          <p
                            style={{
                              color: "green",
                              fontWeight: 500,
                              marginLeft: "-12px",
                            }}
                          >
                            Incoming
                          </p>{" "}
                          <p style={{ fontSize: "12px" }}>
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils.getFormattedNumber(
                                  data?.cashSummary?.incoming
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          md={12}
                          xl={14}
                          style={{ fontSize: "12px" }}
                        >
                          <p
                            style={{
                              color: "#268ddd",
                              fontWeight: 500,
                            }}
                          >
                            Cash (
                            {dayjs(companySettings?.period?.to).format(
                              "DD/MM/YYYY"
                            )}
                            )
                          </p>

                          <p>
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils.getFormattedNumber(
                                  data?.cashSummary?.closingBalance
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                        <Col
                          lg={12}
                          xl={8}
                          md={12}
                          xs={12}
                          style={{ fontSize: "12px", textAlign: "end" }}
                        >
                          <p
                            style={{
                              color: "red",
                              marginLeft: "-12px",
                              fontWeight: 500,
                            }}
                          >
                            Outgoing
                          </p>
                          <p>
                            {hideDasBackground ? (
                              <>****</>
                            ) : (
                              <>
                                {Utils?.getFormattedNumber(
                                  Math.abs(data?.cashSummary?.outgoing)
                                )}
                              </>
                            )}
                          </p>
                        </Col>
                      </Row>
                    </Card>
                  </Skeleton>
                </Col>
              </Row>
              {/* <Row style={{ marginTop: "5px", width: "100%" }}>
                <Col xs={24} md={12} xl={24}>
                  <Skeleton loading={loading}>
                    <Card
                      className="cashflow set-pt"
                      // style={{ marginTop: "10px" }}
                    >
                      <Typography.Title
                        level={5}
                        style={{
                          fontWeight: 500,
                        }}
                      >
                        <span
                          style={{ color: themeData?.themeData?.themeColor }}
                        >
                          Total Expenses Summary
                        </span>
                        <span
                          style={{
                            color: themeData?.themeData?.themeColor,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(
                              `/billing/clients/${currentClient?.id}/banking/bankAccounts`
                            )
                          }
                        >
                          {data?.bankSummary?.title}
                        </span>
                      </Typography.Title>

                      <Row>
                        <LineChart
                          xAxis={[{ data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }]}
                          series={[
                            {
                              data: [2, 3, 5.5, 8.5, 1.5, 5, 1, 4, 3, 8],
                              showMark: ({ index }) => index % 2 === 0,
                            },
                          ]}
                          width={500}
                          height={220}
                        />
                      </Row>
                    </Card>
                  </Skeleton>
                </Col>
              </Row> */}
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default NewDashboard;
